import FacebookIcon from "@mui/icons-material/Facebook";
import XIcon from "@mui/icons-material/X";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LocalizedLink from "./components/LocalizedLink";
import { useTranslation } from "react-i18next";
import "./assets/Footer.css";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <div className="footer">
      <div className="menu">
        <div>
          <LocalizedLink to="/feedback" className="simple-link">
            {t("opinion")}
          </LocalizedLink>
          <LocalizedLink to="/credits" className="simple-link">
            {t("contributors")}
          </LocalizedLink>
        </div>
        <div className="social-icons">
          {[
            {
              icon: <FacebookIcon />,
              link: "https://www.facebook.com/ece.school.ntua",
            },
            {
              icon: <YouTubeIcon />,
              link: "https://www.youtube.com/channel/UCesQBcFYw796R3O3pJO-4vQ",
            },
            {
              icon: <XIcon />,
              link: "https://x.com/ecentua",
            },
            {
              icon: <LinkedInIcon />,
              link: "https://www.linkedin.com/company/school-of-electrical-and-computer-engineering-ntua/",
            },
          ].map((social, index) => (
            <a
              key={index}
              href={social.link}
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon-link"
            >
              {social.icon}
            </a>
          ))}
        </div>
      </div>
      <div className="footer-separator" />
      <div className="menu"></div>
      <div className="copyright-text">
        Copyright &copy; {new Date().getFullYear()} - School of Electrical and Computer Engineering,{" "}
        <b>
          <a
            href="https://www.ntua.gr"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            National Technical University of Athens
          </a>
        </b>
      </div>
    </div>
  );
}
